import { applyFilters, hasFilter } from '@wordpress/hooks';
import { useSelect, select, dispatch, withSelect } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { PanelRow, ToggleControl, RadioControl } from '@wordpress/components';
import Select from 'react-select'

export default () => {

    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { thank_you_page_id, options, modules } = allData;
    if ('undefined' === typeof options) {
        return <></>;
    }
    const { default_settings } = options;
    const { modules: defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys(modules).length > 0 ? modules : defaultModules;
    const isActive = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;

    const { updateSettings } = dispatch('WPTravel/Admin');
    let pageOptions = []

    if ('undefined' != typeof options) {
        if ('undefined' != typeof options.page_list) {
            pageOptions = options.page_list
        }
    }

    let selectedThankYouPage = pageOptions.filter(opt => { return opt.value == thank_you_page_id });
    if (!isActive) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <>
        <PanelRow>
            <label>
                {_wp_travel.setting_strings.pages.thankyou_page}
                {(hasFilter('wp_travel_settings_after_pages_fields', 'wp_travel')) &&
                    applyFilters('wp_travel_settings_after_pages_fields', [])
                }
            </label>
            <div id="wp-travel-thankyou-page" className="wp-travel-field-value">
                <div className="wp-travel-select-wrapper">
                    <Select
                        theme={(theme) => ({
                            ...theme,
                            borderRadius: ".5rem",
                            colors: {
                                ...theme.colors,
                                primary25: "rgb(236 248 244)",
                                primary50: "rgb(204, 204, 204)",
                                primary: "rgb(7 152 18)"
                            }
                        })}
                        options={pageOptions}
                        value={'undefined' != typeof selectedThankYouPage[0] && 'undefined' != typeof selectedThankYouPage[0].label ? selectedThankYouPage[0] : []}
                        onChange={(data) => {
                            if ('' !== data) {
                                updateSettings({
                                    ...allData,
                                    thank_you_page_id: data.value
                                })
                            }
                        }}
                    />
                </div>
                <p className="description">
                    {!(hasFilter('wp_travel_settings_after_pages_fields', 'wp_travel')) &&
                        _wp_travel.setting_strings.pages.thankyou_page_tooltip
                    }
                </p>
            </div>
        </PanelRow>

    </>
}